import { render, staticRenderFns } from "./Templateyh_2.vue?vue&type=template&id=f573da08&scoped=true&"
import script from "./Templateyh_2.vue?vue&type=script&lang=js&"
export * from "./Templateyh_2.vue?vue&type=script&lang=js&"
import style0 from "./Templateyh_2.vue?vue&type=style&index=0&id=f573da08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f573da08",
  null
  
)

export default component.exports